const grep = (array, callback) => array.filter(callback);
export default grep;
